var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{staticClass:"default-input default-textarea",attrs:{"placeholder":_vm.get_placeholder,"required":_vm.required,"name":_vm.name,"title":_vm.get_placeholder},domProps:{"innerHTML":_vm._s(_vm.value)},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }